// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3etcp","largestCol":"styles_largestCol__yGPm8","smallestCol":"styles_smallestCol__2vbNR"};